module.exports = __webpack_public_path__ + "img/pollution_level_1.09898e3e.png";